import React, {useEffect, useState} from "react";
import Logo from "../../assets/images/Logo.svg";
import Help from "../../assets/images/HelpIcon.svg";
import NoImage from "../../assets/images/no-image-avatar.png";
import Notification from "../../assets/images/notification.svg";
import Down from "../../assets/images/DownarrowW.svg";
import {Link, useNavigate} from "react-router";
import "./Header.scss";
import {onLogout} from "../../utils/commonData";
import {useUserContext} from "../../context/UserContext";
import {DEFAULT_PROFILE_IMAGE, IMAGE_URL} from "../../app_url";
import Searchfilter from "../Searchfilter";
import {fetchNotificationApi} from "../../services/apiService";
import {toast} from "react-toastify";
import {motion} from "framer-motion";
import {Menu, X} from "lucide-react";

const Afterloginheader = props => {
  const {userData, setUserData} = useUserContext();
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [notificationList, setNotificationList] = useState();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  const Logout = () => {
    onLogout();
    setUserData(null);
    navigate("/");
  };

  const getNotificationList = async () => {
    try {
      let response = await fetchNotificationApi();
      if (response) {
        if (response.data.res === true) {
          setNotificationList(response.data.data);
        } else {
          // toast.error(response.data.msg, {autoClose: 1500});
        }
      }
    } catch (error) {
      console.error(error);
      // toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
    } finally {
    }
  };

  useEffect(() => {
    if (!['Patient', 'Nurse'].includes(userData?.users?.type)) {
      return undefined;
    }

    getNotificationList();

    const intervalId = setInterval(() => {
      getNotificationList();
    }, 5000);

    return () => clearInterval(intervalId);
  }, [userData?.users?.type]);

  return (
    <div className="TopPart">
      <div className="MainHr MainHr2 patientHdr">
        <div className="TopHr">
          <div className="CustomContainer">
            <div className="logo">
              <Link to="/">
                <img src={Logo} className="MainLogo" alt="logo" />
              </Link>
            </div>

            <div className="HrRight">
              <div className="Navbar">
                <ul>
                  <li>
                    <Link to="/my-appointments">My Appointments</Link>
                  </li>
                  {/* <li>
                    <Link>My Documents</Link>
                  </li> */}
                  <li>
                    <Link to={"/contact-us"}>
                      <img src={Help} className="helpIcon" alt="icon" /> Help Center
                    </Link>
                  </li>
                  <li className="notificationWrapper">
                    <Link to={"/notifications"}>
                      <img src={Notification} className="helpIcon" alt="icon" /> {notificationList?.length > 0 ? <span className="redDot"></span> : null}
                      Notification
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="Hrloginpart">
                {/* <button className="LoginButton">
                  <span>
                    <img src={UserIcon} className="UserIcon" alt="icon" /> To
                    Login
                    </span>
                  </button> */}
                <div className="hideWeb mobileNotification">
                  <li className="notificationWrapper">
                    <Link to={"/notifications"}>
                      <img src={Notification} className="helpIcon" alt="icon" /> {notificationList?.length > 0 ? <span className="redDot"></span> : null}
                    </Link>
                  </li>
                </div>
                <div className="profile-menu">
                  <div className="profile-header" onClick={toggleDropdown}>
                    <img
                      src={userData?.users?.profile_pic_url ?  userData?.users?.profile_pic_url : DEFAULT_PROFILE_IMAGE}
                      className="profile-picture"
                      alt="Profile Picture"
                    />
                    <span className="profile-name">
                      {userData?.users?.first_name} {userData?.users?.last_name}
                    </span>
                    <button className="dropdown-toggle">
                      <img src={Down} className="Downarrow" alt="icon" />
                    </button>
                  </div>
                  {isDropdownOpen && (
                    <div className="dropdown-content">
                      <Link to="/my-profile">My profile</Link>
                      <Link to="/favourite-doctor">Favourite doctor</Link>
                      <Link to={"javascript:void(0);"} onClick={Logout}>
                        Logout
                      </Link>
                    </div>
                  )}
                </div>
                <button className="hamburger_menu" onClick={() => setIsOpen(!isOpen)}>
                  {isOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
              </div>
            </div>
          </div>
        </div>
        {props?.from === "/search-listing" ? (
          <div className="BottompHr">
            <div className="CustomContainer">
              <div className="HeroFrm">
                <Searchfilter />
              </div>
            </div>
          </div>
        ) : null}
      </div>

      {/* Overlay */}
      {isOpen && <div style={{}} className="menu_over" onClick={() => setIsOpen(false)}></div>}

      {/* Sliding Menu */}
      <motion.div initial={{x: "-100%"}} animate={{x: isOpen ? 0 : "-100%"}} transition={{type: "tween", duration: 0.3}} className="mobile_menu">
        <button
          style={{
            position: "absolute",
            top: "16px",
            right: "16px",
            background: "none",
            border: "none",
            color: "white",
            cursor: "pointer",
          }}
          onClick={() => setIsOpen(false)}>
          <X size={24} />
        </button>
        <div className="Navbar">
          <ul>
            <li>
              <Link to="/my-appointments">My Appointments</Link>
            </li>
            <li>
              <Link to={"/contact-us"}>
                <img src={Help} className="helpIcon" alt="icon" /> Help Center
              </Link>
            </li>
          </ul>
        </div>
      </motion.div>
    </div>
  );
};

export default Afterloginheader;
